import { useTranslation } from "react-i18next";
import { Timer, CalendarPlus, Clock, LogOut, LogIn } from "lucide-react";
import { Field } from "../../../components/neu/Field";

const NUMBERS = [
  ["daily_grace_minutes", "branches.dailyGrace", 0, "sky", Timer],
  ["monthly_extra_late_allowance", "branches.monthlyExtraLate", 0, "violet", CalendarPlus],
  ["extra_late_minutes", "branches.extraLateMinutes", 0, "amber", Clock],
  ["checkout_grace_minutes", "branches.checkoutGrace", 30, "emerald", LogOut],
  ["early_checkin_minutes", "branches.earlyCheckin", 60, "rose", LogIn],
];

// Minimum checkout window = daily grace + extra allowance minutes (when extra days are granted).
export const minCheckoutGrace = (policy = {}) =>
  Number(policy.daily_grace_minutes || 0) +
  (Number(policy.monthly_extra_late_allowance || 0) > 0 ? Number(policy.extra_late_minutes || 0) : 0);

// Shared lateness policy editor: company defaults and per-branch overrides.
export const AttendancePolicyFields = ({ value = {}, onChange, defaults }) => {
  const { t } = useTranslation();
  const merged = { ...(defaults || {}), ...value };
  const minimum = minCheckoutGrace(merged);

  return (
    <div className="grid gap-5 sm:grid-cols-2">
      {NUMBERS.map(([key, label, fallback, accent, icon]) => {
        const current = value[key] ?? defaults?.[key] ?? fallback;
        const invalid = key === "checkout_grace_minutes" && Number(current) < minimum;
        return (
          <div key={key}>
            <Field
              label={t(label)} testId={`branch-${key}`} type="number"
              value={current} onChange={(v) => onChange(key, Number(v))}
              accent={accent} icon={icon}
            />
            <p className="mt-1 text-xs text-muted-foreground">{t(`${label}Hint`)}</p>
            {invalid ? (
              <p className="mt-1 text-xs font-semibold text-destructive" data-testid="checkout-grace-error">
                {t("branches.checkoutGraceMin", { minutes: minimum })}
              </p>
            ) : null}
            {defaults && defaults[key] !== undefined ? (
              <p className="mt-1 text-[11px] font-semibold text-muted-foreground" data-testid={`inherited-${key}`}>
                {t("branches.companyDefault", { value: defaults[key] })}
              </p>
            ) : null}
          </div>
        );
      })}
      <div className="sm:col-span-2 rounded-2xl bg-primary/5 p-4">
        <p className="text-sm font-semibold">{t("branches.compensateRule")}</p>
        <p className="mt-1 text-xs text-muted-foreground">{t("branches.compensateRuleHint")}</p>
      </div>
    </div>
  );
};
